import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectVariablesDomain = function (variable) {
    return (variable && variable.variables) || getInitialState();
};
export var selectVariable = createSelector(selectVariablesDomain, function (variable) { return variable; });
